import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getThemeColor } from '../../utils/themeUtils';
import {
  setAppTheme,
  setAppDarkMode,
  setAppGradientEnabled,
  setAppHeaderFixed,
  setAppHeaderInverse,
  setAppSidebarFixed,
  setAppSidebarGrid,
} from '../../app/appSettingsSlice';

function ThemePanel() {
	const dispatch = useDispatch();
	const [expand, setExpand] = useState(false);
	
	// Get app settings from Redux
	const appSettings = useSelector((state) => state.appSettings);
	const { appTheme, appDarkMode, appHeaderFixed, appHeaderInverse, appSidebarFixed, appSidebarGrid, appGradientEnabled } = appSettings;
	
	const themeList = ['red','pink','salmon','orange','yellow','lime','green','teal','cyan','blue','purple','indigo','dark'];
	
	function handleDarkMode(e) {
		dispatch(setAppDarkMode(e.target.checked));
	}
	
	function handleHeaderFixed(e) {
		dispatch(setAppHeaderFixed(e.target.checked));
	}
	
	function handleSidebarFixed(e) {
		dispatch(setAppSidebarFixed(e.target.checked));
	}
	
	function handleHeaderInverse(e) {
		dispatch(setAppHeaderInverse(e.target.checked));
	}
	
	function handleSidebarGrid(e) {
		dispatch(setAppSidebarGrid(e.target.checked));
	}
	
	function handleGradientEnabled(e) {
		dispatch(setAppGradientEnabled(e.target.checked));
	}
	
	function toggleExpand(e) {
		e.preventDefault();
		setExpand(!expand);
	}
	
	function toggleTheme(e, themeName) {
		e.preventDefault();
		dispatch(setAppTheme(themeName));
	}
	
	return (
		<div className={'theme-panel ' + (expand ? 'active' : '')}>
			<a href="#0" onClick={ e => toggleExpand(e) } className="theme-collapse-btn"><i className="fa fa-cog"></i></a>
			<div className="theme-panel-content" data-scrollbar="true" data-height="100%">
				<h5>App Settings</h5>
	
				<div className="theme-list">
					{themeList.map((themeListItem, i) => (
						<div key={i} className={'theme-list-item '+ ((themeListItem === appTheme) ? 'active' : '')}>
							<a 
								href="#0" 
								onClick={ e => toggleTheme(e, themeListItem) } 
								className={'theme-list-link bg-'+ themeListItem}
								style={{
									position: 'relative'
								}}
							>
								{themeListItem === appTheme && (
									<i 
										className="fa fa-check" 
										style={{
											position: 'absolute',
											top: '50%',
											left: '50%',
											transform: 'translate(-50%, -50%)',
											color: getThemeColor(themeListItem),
											fontSize: '14px',
											fontWeight: 'bold'
										}}
									></i>
								)}
							</a>
						</div>
					))}
				</div>
			
			<div className="theme-panel-divider"></div>
	
			<div className="row mt-10px">
				<div className="col-8 control-label text-dark fw-bold">
					<div>Dark Mode <span className="badge bg-primary ms-1 py-2px position-relative" style={{top: '-1px'}}>NEW</span></div>
					 
				</div>
				<div className="col-4 d-flex">
					<div className="form-check form-switch ms-auto mb-0">
						<input type="checkbox" className="form-check-input" name="app-theme-dark-mode" onChange={handleDarkMode} id="appThemeDarkMode" checked={appDarkMode} value="1" />
						<label className="form-check-label" htmlFor="appThemeDarkMode">&nbsp;</label>
					</div>
				</div>
			</div>
	
			<div className="theme-panel-divider"></div>
	
			<div className="row mt-10px align-items-center">
				<div className="col-8 control-label text-dark fw-bold">Header Fixed</div>
				<div className="col-4 d-flex">
					<div className="form-check form-switch ms-auto mb-0">
						<input type="checkbox" className="form-check-input" name="app-header-fixed" onChange={handleHeaderFixed} id="appHeaderFixed" value="1" checked={appHeaderFixed} />
						<label className="form-check-label" htmlFor="appHeaderFixed">&nbsp;</label>
					</div>
				</div>
			</div>
			<div className="row mt-10px align-items-center">
				<div className="col-8 control-label text-dark fw-bold">Header Inverse</div>
				<div className="col-4 d-flex">
					<div className="form-check form-switch ms-auto mb-0">
						<input type="checkbox" className="form-check-input" name="app-header-inverse" onChange={handleHeaderInverse} id="appHeaderInverse" checked={appHeaderInverse} />
						<label className="form-check-label" htmlFor="appHeaderInverse">&nbsp;</label>
					</div>
				</div>
			</div>
			<div className="row mt-10px align-items-center">
				<div className="col-8 control-label text-dark fw-bold">Sidebar Fixed</div>
				<div className="col-4 d-flex">
					<div className="form-check form-switch ms-auto mb-0">
						<input type="checkbox" className="form-check-input" name="app-sidebar-fixed" onChange={handleSidebarFixed} id="appSidebarFixed" checked={appSidebarFixed} />
						<label className="form-check-label" htmlFor="appSidebarFixed">&nbsp;</label>
					</div>
				</div>
			</div>
			<div className="row mt-10px align-items-center">
				<div className="col-8 control-label text-dark fw-bold">Sidebar Grid</div>
				<div className="col-4 d-flex">
					<div className="form-check form-switch ms-auto mb-0">
						<input type="checkbox" className="form-check-input" onChange={handleSidebarGrid} name="app-sidebar-grid" id="appSidebarGrid" checked={appSidebarGrid} />
						<label className="form-check-label" htmlFor="appSidebarGrid">&nbsp;</label>
					</div>
				</div>
			</div>
			<div className="row mt-10px align-items-center">
				<div className="col-md-8 control-label text-dark fw-bold">Gradient Enabled</div>
				<div className="col-md-4 d-flex">
					<div className="form-check form-switch ms-auto mb-0">
						<input type="checkbox" className="form-check-input" name="app-gradient-enabled" onChange={handleGradientEnabled} id="appGradientEnabled" checked={appGradientEnabled} />
						<label className="form-check-label" htmlFor="appGradientEnabled">&nbsp;</label>
					</div>
				</div>
			</div>
	
			<div className="theme-panel-divider"></div>
	 
		</div>
	</div>
	);
};

export default ThemePanel;
